

















































































import Vue from 'vue';
import { Avatar, Button } from '@/components/ds';
import notranslate from '@/components/ds/notranslate';
import { sanitizeDisplayName } from '@/helpers/names';
import { getCookieBannerHeight } from '@/helpers/fixedWidgets';

// o banner de cookies chega por script assíncrono: sondagem leve só com o modal aberto
const COOKIE_BANNER_POLL_MS = 300;
// esconde o botão flutuante do VLibras, que cobriria os botões no celular
export const OPEN_BODY_CLASS = 'logged-account-confirmation-open';
// fica inerte enquanto o modal está aberto; o diálogo vive no body, fora dele
const APP_ROOT_ID = 'app';

export default Vue.extend({
  components: { Avatar, Button },
  directives: { notranslate },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: '',
    },
    email: {
      type: String,
      default: '',
    },
    // chaves de i18n por etapa; o default é a 1ª confirmação (sessão logada)
    titleKey: {
      type: String,
      default: 'loggedAccountConfirmation.title',
    },
    descriptionKey: {
      type: String,
      default: 'loggedAccountConfirmation.description',
    },
    labelKey: {
      type: String,
      default: 'loggedAccountConfirmation.signedInAs',
    },
    confirmKey: {
      type: String,
      default: 'loggedAccountConfirmation.confirm',
    },
  },
  data() {
    return {
      cookieBannerHeight: 0,
      cookieBannerPoll: null as number | null,
    };
  },
  computed: {
    displayName(): string {
      return sanitizeDisplayName(this.name);
    },
    emailParts(): { local: string; domain: string } {
      const at = this.email.lastIndexOf('@');
      if (at < 0) return { local: this.email, domain: '' };
      return { local: this.email.slice(0, at), domain: this.email.slice(at + 1) };
    },
  },
  watch: {
    active: {
      immediate: true,
      handler(value: boolean, oldValue?: boolean) {
        if (value) {
          this.$nextTick(this.focusTitle);
          this.startCookieBannerWatch();
          this.markBackground(true);
        } else {
          this.stopCookieBannerWatch();
          // há uma instância por tela: uma nascendo fechada não desmarca outra aberta
          if (oldValue) this.markBackground(false);
        }
      },
    },
  },
  mounted() {
    document.body.appendChild(this.portalElement());
  },
  beforeDestroy() {
    this.stopCookieBannerWatch();
    if (this.active) this.markBackground(false);
    const portal = this.portalElement();
    const { parentNode } = portal;
    if (parentNode) parentNode.removeChild(portal);
  },
  methods: {
    portalElement(): HTMLElement {
      return this.$refs.portal as HTMLElement;
    },
    // aria-hidden cobre browser sem suporte a inert
    markBackground(open: boolean): void {
      document.body.classList.toggle(OPEN_BODY_CLASS, open);

      const app = document.getElementById(APP_ROOT_ID);
      if (!app) return;

      if (open) {
        app.setAttribute('inert', '');
        app.setAttribute('aria-hidden', 'true');
      } else {
        app.removeAttribute('inert');
        app.removeAttribute('aria-hidden');
      }
    },
    startCookieBannerWatch(): void {
      if (this.cookieBannerPoll !== null) return;
      this.cookieBannerHeight = getCookieBannerHeight();
      this.cookieBannerPoll = window.setInterval(() => {
        this.cookieBannerHeight = getCookieBannerHeight();
      }, COOKIE_BANNER_POLL_MS);
    },
    stopCookieBannerWatch(): void {
      if (this.cookieBannerPoll === null) return;
      window.clearInterval(this.cookieBannerPoll);
      this.cookieBannerPoll = null;
      this.cookieBannerHeight = 0;
    },
    focusTitle(): void {
      const title = this.$refs.title as HTMLElement | undefined;
      if (title) title.focus();
    },
    buttonElement(ref: string): HTMLElement | undefined {
      const button = this.$refs[ref] as Vue | undefined;
      return button?.$el as HTMLElement | undefined;
    },
    // aria-modal não impede o Tab de sair do diálogo: circula entre os dois botões
    trapFocus(event: KeyboardEvent): void {
      const first = this.buttonElement('confirmButton');
      const last = this.buttonElement('switchAccountButton');
      if (!first || !last) return;

      const current = document.activeElement;
      const dialog = this.$refs.dialog as HTMLElement;
      const isOutside = !current || !dialog.contains(current);
      const isOnTitle = current === this.$refs.title;

      if (event.shiftKey) {
        if (isOutside || isOnTitle || current === first) {
          event.preventDefault();
          last.focus();
        }
        return;
      }

      if (isOutside || isOnTitle || current === last) {
        event.preventDefault();
        first.focus();
      }
    },
    onConfirm(): void {
      this.$emit('confirm');
    },
    onSwitchAccount(): void {
      this.$emit('switch-account');
    },
  },
});
